import axiosApi, { setHeader } from "api/root.api";

export const deleteProject = async (token, projectId) => {
  const urlEnd = `/scan/editor/project/v1/${projectId}`;
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.delete(urlEnd);
  const result = response.data;
  return result;
};
